import { render, staticRenderFns } from "./DiscoveryBrandView.vue?vue&type=template&id=471f4152&scoped=true"
import script from "./DiscoveryBrandView.vue?vue&type=script&lang=js"
export * from "./DiscoveryBrandView.vue?vue&type=script&lang=js"
import style0 from "./DiscoveryBrandView.vue?vue&type=style&index=0&id=471f4152&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471f4152",
  null
  
)

export default component.exports